/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-emoji': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M9 .429A8.571 8.571 0 109 17.57 8.571 8.571 0 009 .43zm0 15.356a6.785 6.785 0 110-13.57 6.786 6.786 0 110 13.57zM6.769 8.777c.739 0 1.338-.7 1.338-1.563s-.6-1.562-1.34-1.562c-.739 0-1.339.699-1.339 1.562 0 .864.6 1.563 1.34 1.563zm4.463 0c.74 0 1.34-.7 1.34-1.563s-.6-1.562-1.34-1.562c-.74 0-1.34.7-1.34 1.562 0 .863.6 1.563 1.34 1.563zm1.644 1.416a.675.675 0 00-.9.286C11.946 10.538 11.2 11.9 9 11.9c-2.189 0-2.939-1.35-2.976-1.421a.67.67 0 00-1.196.605c.045.088 1.115 2.155 4.172 2.155 3.058 0 4.126-2.067 4.17-2.156a.665.665 0 00-.295-.89z" _fill="#646464"/>'
  }
})
